import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import React, { ReactNode } from 'react';
import { IconButton, Label, SelectionGroupItem, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import * as styles from './styles';
import { AddressSheetItemDisplay, AddressSheetItemType } from './utils';

interface SelectionGroupAddressItemProps {
  value: AddressSheetItemType;
  name: string;
  description: string;
  priceText: string | undefined;
  addressDisplay: AddressSheetItemDisplay | null;
  icon: ReactNode;
  showIcon: boolean;
  onIconClick: (value: AddressSheetItemType, element: HTMLElement) => void;
}

export const SelectionGroupAddressItem = ({
  value,
  name,
  priceText,
  description,
  addressDisplay,
  icon,
  showIcon,
  onIconClick,
}: SelectionGroupAddressItemProps) => {
  const { t } = useTranslation();

  if (!addressDisplay) return null;

  return (
    <SelectionGroupItem className={styles.selectionGroupItem} value={value}>
      <div className={styles.type}>
        <Typography size="body_accent" variant="m">
          {name}
        </Typography>
        {priceText && (
          <Label
            background={value === FAVORITE_DELIVERY_TYPE.HOME_DELIVERY ? 'accent-light' : 'success-light'}
          >
            {priceText}
          </Label>
        )}
      </div>
      <Typography size="caption" variant="minor" color="text-secondary">
        {description}
      </Typography>
      <div className={styles.cardContent}>
        <Typography className={styles.cardTitle} size="body_long" variant="m">
          {addressDisplay.primary}
        </Typography>

        {showIcon && (
          <IconButton
            className={styles.cardIcon}
            as="div"
            variant="primary"
            size="l"
            label={t('header.main.favorite-address.address-menu.actions.edit')}
            onClick={(event) => {
              event.stopPropagation();
              onIconClick(value, event.currentTarget);
            }}
          >
            {icon}
          </IconButton>
        )}

        {addressDisplay.secondary && (
          <Typography
            className={styles.cardDescription}
            size="caption"
            variant="minor"
            color="text-secondary"
          >
            {addressDisplay.secondary}
          </Typography>
        )}
      </div>
    </SelectionGroupItem>
  );
};
